var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignUpMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.72,374.39c83.79,43.77,219.63,43.77,303.41,0s83.79-114.74,0-158.51-219.63-43.77-303.41,0S6.93,330.62,90.72,374.39Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.83,315.13c-19.71,11.37-19.71,29.82,0,41.2s51.65,11.38,71.36,0,19.7-29.83,0-41.2S311.53,303.75,291.83,315.13Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Envelopes--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.88,227.39a5.74,5.74,0,0,1,2.6-4.5l132.91-76.74a5.78,5.78,0,0,1,5.19,0l2.93,1.7a5.71,5.71,0,0,1,2.6,4.5V254.23a5.77,5.77,0,0,1-2.6,4.5L87.6,335.46a5.74,5.74,0,0,1-5.2,0l-2.92-1.69a5.76,5.76,0,0,1-2.6-4.5Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.88,227.39a5.74,5.74,0,0,1,2.6-4.5l132.91-76.74a5.78,5.78,0,0,1,5.19,0l2.93,1.7a5.71,5.71,0,0,1,2.6,4.5V254.23a5.77,5.77,0,0,1-2.6,4.5L87.6,335.46a5.74,5.74,0,0,1-5.2,0l-2.92-1.69a5.76,5.76,0,0,1-2.6-4.5Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.06,231.43l-11.42-6.6a5.32,5.32,0,0,0-.76,2.56V329.27a5.76,5.76,0,0,0,2.6,4.5l2.92,1.69a5.74,5.74,0,0,0,5.2,0l1.46-.84Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.06,231.43l-11.42-6.6a5.32,5.32,0,0,0-.76,2.56V329.27a5.76,5.76,0,0,0,2.6,4.5l2.92,1.69a5.74,5.74,0,0,0,5.2,0l1.46-.84Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.11,152.35V254.23a5.3,5.3,0,0,1-.81,2.63,5.57,5.57,0,0,1-1.52,1.7l-.1.06-.17.11L87.6,335.46h0a1.85,1.85,0,0,1-1.77.2A1.79,1.79,0,0,1,85,334V232.08a2.26,2.26,0,0,1,2.92-2.3l55.89,13.29,7.32,1.74a4.82,4.82,0,0,0,4.67-1.75l8.48-11.81,57.08-79.47C222.32,150.44,223.11,150.69,223.11,152.35Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.11,152.35V254.23a5.3,5.3,0,0,1-.81,2.63,5.57,5.57,0,0,1-1.52,1.7l-.1.06-.17.11L87.6,335.46h0a1.85,1.85,0,0,1-1.77.2A1.79,1.79,0,0,1,85,334V232.08a2.26,2.26,0,0,1,2.92-2.3l55.89,13.29,7.32,1.74a4.82,4.82,0,0,0,4.67-1.75l8.48-11.81,57.08-79.47C222.32,150.44,223.11,150.69,223.11,152.35Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.51,258.73l.17-.11.1-.06a5.57,5.57,0,0,0,1.52-1.7,5.27,5.27,0,0,0,.81-2.59l-58.83-23,39.4,37.2Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.51,258.73l.17-.11.1-.06a5.57,5.57,0,0,0,1.52-1.7,5.27,5.27,0,0,0,.81-2.59l-58.83-23,39.4,37.2Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,334a1.79,1.79,0,0,0,.81,1.71,1.85,1.85,0,0,0,1.77-.2h0L133.36,309l10.45-66L85,332.27Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,334a1.79,1.79,0,0,0,.81,1.71,1.85,1.85,0,0,0,1.77-.2h0L133.36,309l10.45-66L85,332.27Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.3,256.86a5.57,5.57,0,0,1-1.52,1.7l-.1.06L87.6,335.46h0a1.85,1.85,0,0,1-1.77.2l63.65-101.61A10,10,0,0,1,162,230.23Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.3,256.86a5.57,5.57,0,0,1-1.52,1.7l-.1.06L87.6,335.46h0a1.85,1.85,0,0,1-1.77.2l63.65-101.61A10,10,0,0,1,162,230.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,229.08l61.13,27a10,10,0,0,0,12.52-3.85L222.84,149.5Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,229.08l61.13,27a10,10,0,0,0,12.52-3.85L222.84,149.5Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,229.08l61.56,23a10,10,0,0,0,11.87-3.9l64.41-98.68Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,229.08l61.56,23a10,10,0,0,0,11.87-3.9l64.41-98.68Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.58,239.94a5.71,5.71,0,0,1,2.6-4.5L235.09,158.7a5.74,5.74,0,0,1,5.2,0l2.93,1.69a5.74,5.74,0,0,1,2.59,4.5V266.77a5.76,5.76,0,0,1-2.59,4.5L110.3,348a5.78,5.78,0,0,1-5.19,0l-2.93-1.69a5.77,5.77,0,0,1-2.6-4.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.58,239.94a5.71,5.71,0,0,1,2.6-4.5L235.09,158.7a5.74,5.74,0,0,1,5.2,0l2.93,1.69a5.74,5.74,0,0,1,2.59,4.5V266.77a5.76,5.76,0,0,1-2.59,4.5L110.3,348a5.78,5.78,0,0,1-5.19,0l-2.93-1.69a5.77,5.77,0,0,1-2.6-4.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.77,244l-11.43-6.59a5.29,5.29,0,0,0-.76,2.56V341.82a5.77,5.77,0,0,0,2.6,4.5l2.93,1.69a5.78,5.78,0,0,0,5.19,0l1.47-.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.82,164.89V266.77a5.3,5.3,0,0,1-.81,2.63,5.57,5.57,0,0,1-1.52,1.7l-.1.06-.17.11L110.31,348h0a1.85,1.85,0,0,1-1.77.2,1.79,1.79,0,0,1-.81-1.71V244.62a2.26,2.26,0,0,1,2.92-2.3l55.89,13.29,7.32,1.74a4.82,4.82,0,0,0,4.67-1.75L187,243.79l57.08-79.47C245,163,245.82,163.23,245.82,164.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.22,271.27l.17-.11.1-.06a5.57,5.57,0,0,0,1.52-1.7,5.29,5.29,0,0,0,.8-2.58l-58.82-23L226.38,281Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.71,346.5a1.79,1.79,0,0,0,.81,1.71,1.85,1.85,0,0,0,1.77-.2h0l45.76-26.42,10.45-66-58.81,89.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,269.4a5.57,5.57,0,0,1-1.52,1.7l-.1.06L110.31,348h0a1.85,1.85,0,0,1-1.77.2l63.64-101.6a10,10,0,0,1,12.52-3.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.71,241.63l61.13,27a10,10,0,0,0,12.51-3.85L245.54,162Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.71,241.63l61.55,23a10,10,0,0,0,11.88-3.9L245.54,162Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.07,320.81V218.93a10.94,10.94,0,0,1,1.75-5.43l63.39-88.27a10,10,0,0,1,10.44-3.9l59.61,14.17a25,25,0,0,1,5.52,2.2l2.93,1.69a5.77,5.77,0,0,1,2.59,4.5V245.77a5.79,5.79,0,0,1-2.59,4.5L207.79,327a5.75,5.75,0,0,1-5.19,0l-2.93-1.69A5.76,5.76,0,0,1,197.07,320.81Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.07,320.81V218.93a10.94,10.94,0,0,1,1.75-5.43l63.39-88.27a10,10,0,0,1,10.44-3.9l59.61,14.17a25,25,0,0,1,5.52,2.2l2.93,1.69a5.77,5.77,0,0,1,2.59,4.5V245.77a5.79,5.79,0,0,1-2.59,4.5L207.79,327a5.75,5.75,0,0,1-5.19,0l-2.93-1.69A5.76,5.76,0,0,1,197.07,320.81Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.25,169.69v130c0,1.65,1.17,2.33,2.6,1.5l124.79-72a5.73,5.73,0,0,0,2.6-4.5v-130c0-1.66-1.16-2.33-2.6-1.5L211.85,165.19A5.74,5.74,0,0,0,209.25,169.69Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.69,302.06a1.83,1.83,0,0,1-.92-.24,2.27,2.27,0,0,1-1-2.11v-130a6.23,6.23,0,0,1,2.85-4.94l124.79-72a2.07,2.07,0,0,1,3.35,1.94v130a6.2,6.2,0,0,1-2.85,4.93l-124.79,72A2.85,2.85,0,0,1,210.69,302.06ZM337.8,93.28a1.92,1.92,0,0,0-.91.29L212.1,165.62a5.28,5.28,0,0,0-2.35,4.07v130a1.11,1.11,0,0,0,1.85,1.07l124.79-72a5.27,5.27,0,0,0,2.35-4.07v-130a1.39,1.39,0,0,0-.51-1.25A.86.86,0,0,0,337.8,93.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.56,221.41l-9-5.2a9.52,9.52,0,0,0-.48,2.72V320.81a5.76,5.76,0,0,0,2.6,4.5L202.6,327a5.72,5.72,0,0,0,5.19,0l1.25-.71Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M206.56,221.41l-9-5.2a9.52,9.52,0,0,0-.48,2.72V320.81a5.76,5.76,0,0,0,2.6,4.5L202.6,327a5.72,5.72,0,0,0,5.19,0l1.25-.71Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M343.31,143.89V245.77a5.3,5.3,0,0,1-.81,2.63,5.57,5.57,0,0,1-1.52,1.7l-.1.06-.17.11L207.8,327h0a1.85,1.85,0,0,1-1.77.2,1.79,1.79,0,0,1-.81-1.71V223.62a2.26,2.26,0,0,1,2.92-2.3L264,234.61l7.32,1.74A4.82,4.82,0,0,0,276,234.6l8.48-11.81,57.08-79.47C342.52,142,343.31,142.23,343.31,143.89Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.31,143.89V245.77a5.3,5.3,0,0,1-.81,2.63,5.57,5.57,0,0,1-1.52,1.7l-.1.06-.17.11L207.8,327h0a1.85,1.85,0,0,1-1.77.2,1.79,1.79,0,0,1-.81-1.71V223.62a2.26,2.26,0,0,1,2.92-2.3L264,234.61l7.32,1.74A4.82,4.82,0,0,0,276,234.6l8.48-11.81,57.08-79.47C342.52,142,343.31,142.23,343.31,143.89Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.71,250.27l.17-.11.1-.06a5.57,5.57,0,0,0,1.52-1.7,5.32,5.32,0,0,0,.8-2.59l-58.82-23L323.87,260Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.2,325.5a1.79,1.79,0,0,0,.81,1.71,1.85,1.85,0,0,0,1.77-.2h0l45.76-26.42,10.45-66-58.81,89.2Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.5,248.4a5.57,5.57,0,0,1-1.52,1.7l-.1.06L207.8,327h0a1.85,1.85,0,0,1-1.77.2l63.64-101.6a10,10,0,0,1,12.51-3.84Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.5,248.4a5.57,5.57,0,0,1-1.52,1.7l-.1.06L207.8,327h0a1.85,1.85,0,0,1-1.77.2l63.64-101.6a10,10,0,0,1,12.51-3.84Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.2,199.63a7.28,7.28,0,0,1-6.41-2.2c-1.52-1.69-2.28-4.3-2.28-7.81A27.79,27.79,0,0,1,258,178.14a34.7,34.7,0,0,1,6.86-10A47.51,47.51,0,0,1,275.26,160q5.63-3.24,9.61-3.59c2.67-.24,4.68.45,6.06,2.05s2.06,4.05,2.06,7.33a19.17,19.17,0,0,1-2.24,9.34,15.58,15.58,0,0,1-5.92,6.26,4.36,4.36,0,0,1-3,.78,2,2,0,0,1-1.56-1.51,18.33,18.33,0,0,1-3.14,4.29,19.46,19.46,0,0,1-4.28,3.33c-2.72,1.54-4.89,2-6.49,1.47S264,187.6,264,184.9a16.87,16.87,0,0,1,3-9.49,24.1,24.1,0,0,1,8.16-7.48,15.23,15.23,0,0,1,4.39-1.76,6.71,6.71,0,0,1,3.51,0v10.53c0,.85.15,1.37.44,1.57s.77.1,1.45-.29a6.46,6.46,0,0,0,2.65-3.51,17.31,17.31,0,0,0,.95-6.07q0-3.94-1.72-5.73a5.36,5.36,0,0,0-4.71-1.44,18,18,0,0,0-6.87,2.56,33.62,33.62,0,0,0-11.15,10A22.89,22.89,0,0,0,260,187q0,4.31,1.77,6.29a5.46,5.46,0,0,0,4.88,1.68,17.79,17.79,0,0,0,7-2.57,28.62,28.62,0,0,0,4.15-2.92,22.13,22.13,0,0,0,3.27-3.34,1.76,1.76,0,0,1,.35-.34c.09-.05.18,0,.26.12l1.1,2a1.08,1.08,0,0,1,.09.25,1,1,0,0,1-.31.58,30.92,30.92,0,0,1-4,4,35.21,35.21,0,0,1-4.89,3.44A23.63,23.63,0,0,1,264.2,199.63Zm13-18.8a6.7,6.7,0,0,0,1.58-4v-6.1a8.62,8.62,0,0,0-4,1.38,13.79,13.79,0,0,0-4.74,4.41,10.19,10.19,0,0,0-1.75,5.67c0,1.69.42,2.7,1.27,3s2.16,0,3.95-1.07A12.62,12.62,0,0,0,277.24,180.83Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.87,354.09h0l.19-.17c.14-.12.29-.24.42-.37l.45-.44.45-.43a10.47,10.47,0,0,0,.75-.78l3.56,2.66,2.37,1.77a0,0,0,0,1,0,0,11.57,11.57,0,0,0-2.08,3.17s-.71,1.15-3.12.57C325.88,359.38,325.41,355,325.87,354.09Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,352.87c-2.72-3.16-.3-8.41,2.34-15.22,2.9-7.49,7.38-20.22,7.38-20.22l31.81-6.57s33.89-.65,37,5.83c2.52,5.19-19.8,13-23,13.28L326.94,331l-2.06,1-13.76,17.41Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.61,322a80.06,80.06,0,0,0-6.89,8c-5.73,8-14.8,22.53-14.8,22.53s1.41,4.6,5.74,4.4c0,0,29.8-27.83,32.24-30.4,3.69-3.9,6.65-10.33.27-10.86S352.09,319.32,349.61,322Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.56,330.16s5.32-7.78,10.83-11c0,0-5.48,1.08-13.78,11.18Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.56,330.16s5.32-7.78,10.83-11c0,0-5.48,1.08-13.78,11.18Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.18,340l-2.09.4,1.94,7.17s1.88-.18,2.53-.14a10.67,10.67,0,0,0,2.71-1.05l-.5-4.38-2.3-2.4Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.68,341.69a7.82,7.82,0,0,1,4.38,4.46,22.42,22.42,0,0,1,1.09,3.24c.33,1.16.17,3.13-1.3,3.45a2.43,2.43,0,0,1-1.39-.25c-2.95-1.14-5.83-2.46-8.85-3.42a29.38,29.38,0,0,0-8.05-1.75,5.57,5.57,0,0,0-.24-6.41,3.88,3.88,0,0,0-2.14-1c.76-.34,1.47-.78,2.2-1.19a6.67,6.67,0,0,1,4.67-1.15c1.26.27,2.22,1.27,3.29,2C358.38,341,360.35,340.91,362.68,341.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.29,346c2.63-.81,6.83-1.53,19.29-2.17s29.51-3.44,29.51-3.44c2.9,2.79,1.94,7.17,1.94,7.17s-22.13,7-29.34,7.93c-11.48,1.48-15.44,1.37-20.62.26C290.25,354.5,286.58,348.67,295.29,346Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.83 286.65 350.19 309.02 343.49 313.14 330.61 291.33 340.83 286.65",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.47,265.57c5.12.06,10.75,1.92,12.69,5.93l8,16.5s-4.52,6.62-11.7,6.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.43,300.34c.06-.87,1.31-5.12,2.65-9.7L299.8,294l-2.61,8.23L289,310A12.88,12.88,0,0,1,287.43,300.34Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,265.88c-6.1,1.47-14.41,3.38-16.82,10s-5.86,18.31-5.86,18.31c1.34,2.32,8.69,4.24,11.24,2.9l1.2-4v24.32c4.77,5.19,28.3,3.86,31.81-6.57V277.71c0-5.3-2.94-11.67-11.07-12.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.73 293.11 303.79 283.48 300.73 297.42 300.73 293.11",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.68,238.77a3.63,3.63,0,0,0-3,1c-1.29,1.32-1,3.76,0,9.36l4,.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.89,237.15a6.2,6.2,0,0,0,2.49-.51c1.22-.7,1.54.69.87,1.89a5.69,5.69,0,0,1-4.62,3.08c0-.17-1.14-3.11-1.14-3.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.55,249.64c-.59.35-1.44-.78-2.17-1.55a2.56,2.56,0,0,0-4.29.7c-1.21,2.55,1.54,5.94,3.15,7.06a2.83,2.83,0,0,0,3.31.28l.42,9.75a10.39,10.39,0,0,0,7.84,5.95c5.72.77,4.54-3.95,2.66-6.26V262a13.72,13.72,0,0,0,4.36.22c.74-.2,2.52-2.35,3.67-4.76,1.29-2.7,3.44-7.5,1.53-15.63-2.06-8.72-11.43-9-17-5.47S310.55,249.64,310.55,249.64Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.55,250.63c-.3,0-1.43-1.87-2.17-2.54-1-.93.3-9.32.3-9.32s-1-3.19,1-5.3,5.92-1.76,8.78-1.86a25.7,25.7,0,0,0,10.2-2.05c4.06-1.76,4.36-2,4.86-.19s.7,5.86-1.72,8.59l-1.32,2.15s-1.23,1-5,1.5-10.23-1.57-11-1.68c-1.1-.15-1.33.91-1.92,3.81C312,246.29,311.55,250.61,310.55,250.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.69,239.42l-3.58-1.92a2,2,0,0,1,2.71-.89A2.14,2.14,0,0,1,308.69,239.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.46,262s-5.3-1.07-7.15-2a6.13,6.13,0,0,1-2.56-2.54,8.4,8.4,0,0,0,1.46,3c1.35,1.73,8.25,3,8.25,3Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.63,249.44a1.06,1.06,0,1,1-1.06-1.1A1.08,1.08,0,0,1,321.63,249.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.51,245.44l-2.28,1.25a1.38,1.38,0,0,1,.53-1.81A1.27,1.27,0,0,1,320.51,245.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,256.54l2.43.92a1.28,1.28,0,0,1-1.65.8A1.36,1.36,0,0,1,321,256.54Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.1,246.32l-2.07-1.6a1.26,1.26,0,0,1,1.8-.27A1.37,1.37,0,0,1,331.1,246.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.46,249.14a1.06,1.06,0,1,1-1.06-1.1A1.08,1.08,0,0,1,330.46,249.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.46 249.01 324.46 255.33 327.96 254.92 325.46 249.01",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.94,320.78l-21.55-12.44a1.25,1.25,0,0,0-1.24,0l-37.79,21.82L323.52,343Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.32 341.13 311.7 334.43 345.68 314.81 357.36 321.48 323.32 341.13",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.61 322.49 317.83 322.61 323.52 325.9 333.65 320.05 333.86 319.93 327.95 316.52 317.61 322.49",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.83 322.61 323.52 325.9 333.65 320.05 327.95 316.76 317.83 322.61",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.36,330.16v.51a2.09,2.09,0,0,0,1,1.8l20.08,11.59a2.07,2.07,0,0,0,2.08,0l36.34-21a2.1,2.1,0,0,0,1-1.8v-.51L323.52,343Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.52,343v1.38a2,2,0,0,0,1-.28l36.34-21a2.1,2.1,0,0,0,1-1.8v-.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.11,343.27a2.47,2.47,0,0,0,2.12-.17l36.18-20.89a2.43,2.43,0,0,0,1.19-1.72l4-23.61a2.85,2.85,0,0,0,0-.41,2.48,2.48,0,0,0-.73-1.75l-37.6,21.71a1.81,1.81,0,0,0-.88,1.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.52,343l.25.14a3.59,3.59,0,0,0,.34.17l4.28-25.57a1.81,1.81,0,0,1,.88-1.27l37.6-21.71a3.14,3.14,0,0,0-.5-.38L328.7,316.09a1.83,1.83,0,0,0-.89,1.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.48,321.46a8,8,0,0,1,3.65-4.69c1.75-1,2.95-.55,2.69,1a8,8,0,0,1-3.65,4.69C345.42,323.51,344.22,323,344.48,321.46Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.19,302.21s6.49,25,9.23,26.79,7.84,3.1,10.28,4,3.55,2.13,3.13,2.47-3.94.71-5.16,1.14.36,2.4,3.06,4.49,5,1.9,4.7,3.29-6.32,2.78-11.4-.2-6.62-7-9.65-10.41S291.43,316.2,289,310c0,0,.23-11.52,4-10.79S297.19,302.21,297.19,302.21Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.07,352.87c.46,1.11,2.05,4.17,5.59,4l8.7-8.14Z",
    style: {
      fill: "#523BD0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.07,352.87c.46,1.11,2.05,4.17,5.59,4l8.7-8.14Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.32,357.84a.49.49,0,0,1,0,.11A.49.49,0,0,0,333.32,357.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.7,367.19a20,20,0,0,1,1.27-7.68h0a3.18,3.18,0,0,1-2.91.38c-2.91-.87-3.64-4.93-3.18-5.81h0c-.42.37-.86.72-1.29,1.08a6.63,6.63,0,0,0-2.75,3.95c-.2,1.27.39,2.52.68,3.78.56,2.4,0,4.9-.09,7.36a7.85,7.85,0,0,0,2.59,5.68,21.31,21.31,0,0,0,2.64,2.19,2.48,2.48,0,0,0,4.33-1.77C331.61,373.23,330.88,370.44,330.7,367.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,356.35c-.27.51-.51,1-.72,1.49C333.53,357.36,333.77,356.86,334,356.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.86,354.08h0l.19-.17Z",
    style: {
      fill: "#37474f"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUpMailIcon);
export default __webpack_public_path__ + "static/media/SignUpMailIcon.0bfe7ef229dacb04e9dd3881728ebd16.svg";
export { ForwardRef as ReactComponent };